import React from 'react';
import { useUser } from '../../context/UserContext';
import { useLocation } from 'react-router-dom';

// Import components for different user roles
import FinancialDetails from '../LandingPages/FinancialDetails'; // For both external and internal users

const ConditionalFinancialDetailsRoute = () => {
  const { userData } = useUser();
  const location = useLocation();

  // Check if we're in a protected route context (/d/* or /admin/*)
  // These routes already have their own layouts with sidebars
  const isProtectedRoute = location.pathname.startsWith('/d/') || location.pathname.startsWith('/admin/');

  // Check if user is external (only EXTERNAL_USER role)
  const isExternalUser = () => {
    if (!userData || !userData.roles || userData.roles.length === 0) {
      // If in protected route, assume internal/admin (skip layout)
      // If in public route, assume external (show layout)
      return !isProtectedRoute;
    }
    
    // Check if user has EXTERNAL_USER role
    return userData.roles.includes('EXTERNAL_USER');
  };

  // If we're in a protected route (/d/* or /admin/*), always skip the landing layout
  // because these routes already have their own layouts (App with ModernSidebar or AdminLayout with AdminSidebar)
  if (isProtectedRoute) {
    console.log('Rendering FinancialDetails in protected route context (skipLayout=true) for user:', userData?.username);
    return <FinancialDetails skipLayout={true} />;
  }

  // For public routes, check user role
  if (isExternalUser()) {
    console.log('Rendering external FinancialDetails component for user:', userData?.username);
    return <FinancialDetails skipLayout={false} />;
  } else {
    console.log('Rendering internal FinancialDetails component for user:', userData?.username);
    // For admin/internal users in public route, skip the landing layout
    return <FinancialDetails skipLayout={true} />;
  }
};

export default ConditionalFinancialDetailsRoute;

